import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WmTransitionModule } from '../transition/index';
import { ExpandableComponent } from './expandable.component';

@NgModule({
	declarations: [ExpandableComponent],
	imports: [CommonModule, WmTransitionModule],
	exports: [ExpandableComponent]
})
export class WmExpandableModule {}
